import ContractorInterface from "../../../common/interfaces/ContractorInterface";
import {
    setInsuranceActiveContractor,
    setLeaseActiveContractor,
    setShowContactorNotice,
} from "../vehicleInformationSlice";
import { setGeneralStep } from "../../helpType/helpTypeSlice";
import { GeneralStepsEnum } from "../../../common/constants/GeneralStepsEnum";
import { unsetAppointment } from "../../appointment/appointmentSlice";
import { handleContractorClick } from "./handleContractorClick";
import { AppDispatch } from "../../../app/store";
import { ContractorEnum } from "../../../common/constants/ContractorEnum";

interface Props {
    dispatch: AppDispatch;
    contractors?: object[];
    option: {
        label: string;
        value: string | number;
    } | null;
    type: ContractorEnum;
}

export const handleContractorSelect = (props: Props): void => {
    const { dispatch, contractors, option, type } = props;

    if (!option) return;

    const selectedId = Number.parseInt(option.value as string);
    const selected = contractors?.find(
        (c: ContractorInterface) => c.id === selectedId,
    ) as ContractorInterface | undefined;
    const hasRedirect = !!selected?.redirect_url;

    switch (type) {
        case ContractorEnum.LEASE:
            dispatch(setLeaseActiveContractor(selectedId));
            break;
        case ContractorEnum.INSURANCE:
            dispatch(setInsuranceActiveContractor(selectedId));
            break;
    }

    if (hasRedirect) {
        dispatch(setShowContactorNotice(true));
        dispatch(
            setGeneralStep(
                type === ContractorEnum.LEASE
                    ? GeneralStepsEnum.Lease
                    : GeneralStepsEnum.Insurance,
            ),
        );
        dispatch(unsetAppointment());
        return;
    }

    dispatch(setShowContactorNotice(false));
    handleContractorClick({
        dispatch,
        activeContractorId: selectedId,
        type,
    });
};
